import { render, staticRenderFns } from "./DetailRecruitment.vue?vue&type=template&id=35c61913&"
import script from "./DetailRecruitment.vue?vue&type=script&lang=js&"
export * from "./DetailRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./DetailRecruitment.vue?vue&type=style&index=0&id=35c61913&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c61913')) {
      api.createRecord('35c61913', component.options)
    } else {
      api.reload('35c61913', component.options)
    }
    module.hot.accept("./DetailRecruitment.vue?vue&type=template&id=35c61913&", function () {
      api.rerender('35c61913', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailRecruitment.vue"
export default component.exports